module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_Letter-to-Tudor_1Jul-11-1961_FPO.699497c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_Letter-to-Tudor_1Jul-11-1961_FPO.jpg
// module id = E+RI
// module chunks = 0